module.exports = __webpack_public_path__ + "static/media/blackoutDay_listing_xLarge.22db00f3.jpg";